import { GetRecoilValue } from 'recoil';
import { Color } from '../../enums/Color.enum';
import { DeviceType } from '../../enums/Device.enum';
import { Fit } from '../../enums/Fit.enum';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { SelectionType } from '../../enums/SelectionType.enum';
import { ViewVariant } from '../../models/ShopifyVariant.model';
import { ViewProduct } from '../../models/ViewProduct.model';
import { Denomination } from '../../product_detail/components/denomination.enum';
import { LongSize } from '../../product_detail/components/size.enum';
import { productsState } from '../selectors';

export const productFromHandle = (get: GetRecoilValue, handle: ProductHandle): ViewProduct => {
  const products = get(productsState);
  return handle && (products[handle] as ViewProduct);
};

export const variantLookup = (
  product: ViewProduct,
  color: Color | undefined,
  size: LongSize | undefined,
  fit: Fit | undefined,
  denomination: Denomination | undefined,
): ViewVariant | undefined => {
  const productVariants = product?.variants as ViewVariant[];
  if (product?.handle === ProductHandle.EGiftCard) {
    return productVariants?.find((v) => v.denomination === denomination);
  } else {
    return productVariants?.find((v) => v.color === color && v.size === size && (product.fits.length === 0 || v.fit === fit));
  }
};

export const getDeviceType = (): DeviceType => {
  const width = window.navigator.userAgent.match(/instagram/i) ? screen.width : window.innerWidth;

  const isMobile = width < 768;
  const isDesktop = width > 1024;
  const isTablet = !isMobile && !isDesktop;
  return isMobile ? DeviceType.Mobile : isTablet ? DeviceType.Tablet : DeviceType.Desktop;
};
